firebird.controller('waitingRoomMarqueeCtrl', [
    '$window',
    '$scope',
    'config',
    'logService',
    'helperService',
    'meetingService',
    'socketService',
    function ($window, $scope, config, logService, helperService, meetingService, socketService) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'waitingRoomMarqueeCtrl');

        self.holdRoomMusic = config.webinar.holdMusic;
        self.welcomeMsg = '';
        self.welcomeMsgRetrievedFromServer = false;
        self.meeting = meetingService.getCurrentMeeting();
        self.meetingDisplayInfo = {
            title: self.meeting.title,
            hostDisplayName: self.meeting.hostDisplayName,
            date: '',
            startTime: '',
            timeZone: ''
        };

        $scope.$on('waiting-room-msg-updated', onWaitingRoomMsgUpdated);
        $scope.$on('update-local-meeting-title', onUpdateLocalMeetingTitle);

        init();

        ////////////////////////

        function init() {
            socketService.send({
                message: 'retrieve-waiting-room-msg',
                data: '',
                callback: function (newMsg) {
                    self.welcomeMsg = newMsg || '';
                    self.welcomeMsgRetrievedFromServer = true;
                    digest();
                }
            });

            //Splice (GMT-XX:XX) from timezone string for display
            self.meetingDisplayInfo.timeZone = self.meeting.timeZone.substring(12, self.meeting.timeZone.length);
            self.meetingDisplayInfo.date = $window.moment(self.meeting.startDate).format('dddd, MMMM DD, YYYY');
            self.meetingDisplayInfo.startTime = $window.moment(self.meeting.startTime).format('hh:mma');
        }

        function onWaitingRoomMsgUpdated(e, data) {
            if (data) {
                var newMsg = data.message || '';
                logService.log('Waiting Room Msg Updated: ', newMsg || 'empty string');

                self.welcomeMsg = newMsg;
                digest();
            } else {
                logger.error('onWaitingRoomMsgUpdated', 'Invalid data object for Waiting Room Welcome Message', data);
            }
        }

        function onUpdateLocalMeetingTitle() {
            var newTitle = meetingService.getTitle();

            if (self.meetingDisplayInfo.title !== newTitle) {
                self.meetingDisplayInfo.title = newTitle;
                digest();
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
